import { render, staticRenderFns } from "./CompanyDashboard.vue?vue&type=template&id=2e428e83&scoped=true&"
import script from "./CompanyDashboard.vue?vue&type=script&lang=js&"
export * from "./CompanyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDashboard.vue?vue&type=style&index=0&id=2e428e83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e428e83",
  null
  
)

export default component.exports